import React, { useEffect } from "react";
import { groupBy } from "lodash";

function PickupList({ selectedOrdersData, setIsPickupList }) {
  useEffect(() => {
    const printContents = document.getElementById("printContent").innerHTML;
    const newWin = window.open("_blank");
    newWin.document.write(printContents);
    newWin.print();
    newWin.close();
    setIsPickupList(false);
  }, [selectedOrdersData]);

  let prescriptionData = [];
  let printData = [];

  selectedOrdersData.forEach((order) => {
    const prescriptions = order.prescription || [];
    prescriptions.forEach((prescription) => {
      const parsedPrescriptions = JSON.parse(
        prescription.prescription
      ).prescription;
      parsedPrescriptions.forEach((prescriptionItem) => {
        if (
          !prescriptionItem.showRecommendation ||
          prescriptionItem.isRecommended === false
        ) {
          printData.push(prescriptionItem);
        }
      });
      prescriptionData = [...prescriptionData, ...printData];
    });
  });

  let pickupList = {};

  const group = groupBy(prescriptionData, (prescriptionItem) => prescriptionItem.Medicine);

  for (let medicineGroupKey in group) {
    const medicineArray = group[medicineGroupKey];
    const medicineName = medicineArray[0].Medicine;
    const count = medicineArray.reduce((acc, med) => {
      let quantity = med.quantity;
      if (!quantity) quantity = 1;
      return acc + Number(quantity);
    }, 0);
    pickupList[medicineName] = count;
  }

  return (
    <div id="printContent">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <table
          style={{
            border: "1px solid black",
            borderCollapse: "collapse",
            width: "80%",
            margin: "10px auto",
          }}
        >
          <thead>
            <tr>
              <th
                className="pickup-list-data"
              >
                Product Name
              </th>
              <th className="pickup-list-data"
              >
                Count
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(pickupList).map(([productName, productCount]) => (
              <tr key={productName}>
                <td
                  className="pickup-list-data"
                >
                  {productName}
                </td>
                <td className="pickup-list-data"
                >
                  {productCount}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PickupList;
